module.exports = __webpack_public_path__ + "img/1.03b1b291.jpg";